export const SET_TAXONOMY_DATA = "SET_TAXONOMY_DATA";
export const SET_CURRENT_TAXONOMY_L2_DATA = "SET_CURRENT_TAXONOMY_L2_DATA";
export const SET_T1T2_PRODUCT_DATA = "SET_T1T2_PRODUCT_DATA";

export function setTaxonomyDataRequest(data) {
  return {
    type: SET_TAXONOMY_DATA,
    payload: data,
  };
}

export function setCurrentTaxonomyL2DataRequest(data) {
  return {
    type: SET_CURRENT_TAXONOMY_L2_DATA,
    payload: data,
  };
}

export function setT1T2ProductDataRequest(data) {
  return {
    type: SET_T1T2_PRODUCT_DATA,
    payload: data,
  };
}
